document.addEventListener('DOMContentLoaded', function () {
    const items = document.querySelectorAll('.solutions__item-content');
    const thumbs = document.querySelectorAll('.solutions__item-thumb');

    items.forEach((item, index) => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('active');
                        thumbs[index].classList.add('active');
                    } else {
                        entry.target.classList.remove('active');
                        thumbs[index].classList.remove('active');
                    }
                });
            },
            {
                root: null,
                threshold: 1,
                rootMargin: '0px',
            }
        );
        observer.observe(item);
    });
});
